import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { customReportPropTypes, customReportDataPropTypes, customReportsPropTypes } from '../../shared/customReports/propTypes';
import { OptionsPropType } from '../../shared/propTypes/common';

import CustomReportEditor from './customReportEditor/customReportEditor.component';
import CustomReportSetEditor from './customReportSetEditor/customReportSetEditor.component';
import ModalNames from '../../shared/customReports/modalNames';

import { withPermissions, permissions } from '../../shared/authorization';
import { modalDataSelector } from '../../shared/modals/modals.selectors';

import {
  hideCustomReportForm,
  saveCustomReport,
  disableReadOnlyMode,
  testCustomReport,
  showCustomReportModalForEdit,
  hideCustomReportModalForEdit,
  fetchCustomReportParams,
  showCustomReportModalForParam,
  hideCustomReportModalForParam,
  closeCustomReportPreview,
  showTestCustomReportQueryParamModal,
  hideTestCustomReportQueryParamModal,
  verifyParamOptionsQuery,
  showExportCustomReportInsertQueryModal,
} from './store/actions';

import {
  readOnlySelector,
  isSavingCustomReportQueryInProgressSelector,
  isFetchingCustomReportParamsSucceedSelector,
  isReportSetOpenSelector,
  customReportSelector,
  customReportDataSelector,
  customReportParamsSelector,
  reportParamToEditOptionsSelector,
  isVerifyingParamToEditQuerySelector,
} from './store/selectors';

class CustomReportsEditorForm extends PureComponent {
  static propTypes = {
    hideCustomReportForm: PropTypes.func.isRequired,
    saveCustomReport: PropTypes.func.isRequired,
    disableReadOnlyMode: PropTypes.func.isRequired,
    testCustomReport: PropTypes.func.isRequired,
    showCustomReportModalForEdit: PropTypes.func.isRequired,
    deselectCustomReport: PropTypes.func.isRequired,
    setCustomReportQueryModified: PropTypes.func.isRequired,
    showCustomReportQueryForm: PropTypes.func.isRequired,
    hideCustomReportModalForEdit: PropTypes.func.isRequired,
    fetchCustomReportParams: PropTypes.func.isRequired,
    showCustomReportModalForParam: PropTypes.func.isRequired,
    hideCustomReportModalForParam: PropTypes.func.isRequired,
    closeCustomReportPreview: PropTypes.func.isRequired,
    customReportData: customReportDataPropTypes,

    showExportCustomReportInsertQueryModal: PropTypes.func.isRequired,

    isSavingCustomReportQueryInProgress: PropTypes.bool.isRequired,
    isTestCustomReportQueryInProgress: PropTypes.bool.isRequired,
    isReportSetOpen: PropTypes.bool.isRequired,
    readOnly: PropTypes.bool.isRequired,
    isFetchingCustomReportParams: PropTypes.bool.isRequired,
    wasVerifyingCustomReportParamQuerySuccessful: PropTypes.bool.isRequired,

    customReports: customReportsPropTypes,

    customReportParamsOptions: PropTypes.objectOf(OptionsPropType),

    openForEdit: PropTypes.bool,
    canModify: PropTypes.bool,

    customReportQueryToEdit: customReportPropTypes.isRequired,

    editCustomReportModalData: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      data: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        sql: PropTypes.string.isRequired,
      }),
    }),

    customReportParamModalData: PropTypes.shape({
      show: PropTypes.bool.isRequired,
      data: PropTypes.objectOf(PropTypes.string),
    }).isRequired,

    reportParamToEditOptions: OptionsPropType,

    testCustomReportQueryParamModalData: PropTypes.func.isRequired,
    showTestCustomReportQueryParamModal: PropTypes.func.isRequired,
    hideTestCustomReportQueryParamModal: PropTypes.func.isRequired,
    verifyParamOptionsQuery: PropTypes.func.isRequired,

    isVerifyingParamToEditQuery: PropTypes.bool.isRequired,

  };

  constructor(props) {
    super(props);

    this.state = {
      openForEdit: this.props.openForEdit || false,
    };
  }

  disableReadOnlyMode = () => {
    const { disableReadOnlyMode } = this.props;
    disableReadOnlyMode();
  };

  hideCustomReportForm = () => {
    const { hideCustomReportForm, deselectCustomReport } = this.props;
    hideCustomReportForm();
    deselectCustomReport();
  };

  render() {
    const { openForEdit } = this.state;

    const {
      saveCustomReport,
      testCustomReport,
      showCustomReportModalForEdit,
      editCustomReportModalData,
      setCustomReportQueryModified,
      showCustomReportQueryForm,
      hideCustomReportModalForEdit,
      canModify,
      isSavingCustomReportQueryInProgress,
      isTestCustomReportQueryInProgress,
      isFetchingCustomReportParams,
      isReportSetOpen,
      readOnly,
      customReportQueryToEdit,
      customReports,
      customReportData,
      closeCustomReportPreview,
      fetchCustomReportParams,
      customReportParamsOptions,
      showCustomReportModalForParam,
      hideCustomReportModalForParam,
      customReportParamModalData,
      reportParamToEditOptions,
      testCustomReportQueryParamModalData,
      showTestCustomReportQueryParamModal,
      hideTestCustomReportQueryParamModal,
      isVerifyingParamToEditQuery,
      verifyParamOptionsQuery,
      showExportCustomReportInsertQueryModal,
    } = this.props;

    if (isReportSetOpen) {
      return (
        <CustomReportSetEditor
          setCustomReportQueryModified={setCustomReportQueryModified}
          customReportSetToEdit={customReportQueryToEdit}
          customReports={customReports}
          readOnly={readOnly}
          canModify={canModify}
          openForEdit={openForEdit}
          saveCustomReport={saveCustomReport}
          customReportData={customReportData}
          closeCustomReportPreview={closeCustomReportPreview}
          isTestCustomReportSetInProgress={isTestCustomReportQueryInProgress}
          testCustomReportSet={testCustomReport}
          isSavingCustomReportSetInProgress={isSavingCustomReportQueryInProgress}
          hideCustomReportForm={this.hideCustomReportForm}
          showCustomReportQueryForm={showCustomReportQueryForm}
          disableReadOnlyMode={this.disableReadOnlyMode}
          fetchCustomReportParams={fetchCustomReportParams}
          customReportParamsOptions={customReportParamsOptions}
          isFetchingCustomReportParams={isFetchingCustomReportParams}
          showExportCustomReportInsertQueryModal={showExportCustomReportInsertQueryModal}
        />
      );
    }

    return (
      <CustomReportEditor
        saveCustomReport={saveCustomReport}
        customReportData={customReportData}
        closeCustomReportPreview={closeCustomReportPreview}
        setCustomReportQueryModified={setCustomReportQueryModified}
        showCustomReportQueryForm={showCustomReportQueryForm}
        hideCustomReportForm={this.hideCustomReportForm}
        showCustomReportModalForEdit={showCustomReportModalForEdit}
        hideCustomReportModalForEdit={hideCustomReportModalForEdit}
        disableReadOnlyMode={this.disableReadOnlyMode}
        testCustomReportQuery={testCustomReport}
        customReportQueryToEdit={customReportQueryToEdit}
        editCustomReportModalData={editCustomReportModalData}
        fetchCustomReportParams={fetchCustomReportParams}
        canModify={canModify}
        isSavingCustomReportQueryInProgress={isSavingCustomReportQueryInProgress}
        isTestCustomReportQueryInProgress={isTestCustomReportQueryInProgress}
        isFetchingCustomReportParams={isFetchingCustomReportParams}
        readOnly={readOnly}
        openForEdit={openForEdit}
        customReportParamsOptions={customReportParamsOptions}
        showCustomReportModalForParam={showCustomReportModalForParam}
        hideCustomReportModalForParam={hideCustomReportModalForParam}
        customReportParamModalData={customReportParamModalData}
        testCustomReportQueryParamModalData={testCustomReportQueryParamModalData}
        hideTestCustomReportQueryParamModal={hideTestCustomReportQueryParamModal}
        showTestCustomReportQueryParamModal={showTestCustomReportQueryParamModal}
        reportParamToEditOptions={reportParamToEditOptions}
        isVerifyingParamToEditQuery={isVerifyingParamToEditQuery}
        verifyParamOptionsQuery={verifyParamOptionsQuery}
        showExportCustomReportInsertQueryModal={showExportCustomReportInsertQueryModal}
      />
    );
  }
}

const mapStateToProps = state => ({
  customReportQueryToEdit: customReportSelector(state),
  readOnly: readOnlySelector(state),
  isSavingCustomReportQueryInProgress: isSavingCustomReportQueryInProgressSelector(state),
  isFetchingCustomReportParams: isFetchingCustomReportParamsSucceedSelector(state),
  isReportSetOpen: isReportSetOpenSelector(state),
  editCustomReportModalData: modalDataSelector(state, ModalNames.CustomReportEdit),
  customReportParamsOptions: customReportParamsSelector(state),
  customReportData: customReportDataSelector(state),
  reportParamToEditOptions: reportParamToEditOptionsSelector(state),
  customReportParamModalData: modalDataSelector(state, ModalNames.CustomReportParam),
  testCustomReportQueryParamModalData: modalDataSelector(state, ModalNames.CustomReportTestQueryParam),
  isVerifyingParamToEditQuery: isVerifyingParamToEditQuerySelector(state),
});

const ConnectedCustomReportsEditorForm = connect(
  mapStateToProps,
  {
    hideCustomReportForm,
    saveCustomReport,
    disableReadOnlyMode,
    testCustomReport,
    showCustomReportModalForEdit,
    hideCustomReportModalForEdit,
    fetchCustomReportParams,
    showCustomReportModalForParam,
    hideCustomReportModalForParam,
    closeCustomReportPreview,
    showTestCustomReportQueryParamModal,
    hideTestCustomReportQueryParamModal,
    verifyParamOptionsQuery,
    showExportCustomReportInsertQueryModal,
  }
)(CustomReportsEditorForm);

export default withPermissions(permissions.CUSTOM_REPORTS_MANAGEMENT)(
  ConnectedCustomReportsEditorForm
);
